module.exports = __webpack_public_path__ + "static/media/bhujia-mixture.8ce15473.jpg";